import { Injectable, HostListener, OnInit } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserService implements OnInit{

  private userName: string;
  private ucloudSession: String = "";
  private group: String = "";

  constructor() { }

  ngOnInit(){
    console.log("aqui", sessionStorage.getItem("user")) 
    if(sessionStorage.getItem("user")){
      this.setUserName(sessionStorage.getItem("user"));
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    sessionStorage.setItem("user", this.getUserName());
  }

  setUserName(name){
    console.log("name", name)
    this.userName = name
  };

  getUserName(){
    console.log("get", this.userName)
    return this.userName
  };

}
